import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiFetch } from "../../shared/api";

function normalizePagedList(data) {
  if (Array.isArray(data)) {
    return { results: data, count: data.length, next: null, previous: null };
  }
  const results = Array.isArray(data?.results) ? data.results : [];
  const count = typeof data?.count === "number" ? data.count : results.length;
  return {
    results,
    count,
    next: data?.next ?? null,
    previous: data?.previous ?? null,
  };
}

export const fetchReturns = createAsyncThunk(
  "returns/fetch",
  async ({ storeId, startDate, endDate, page = 1, pageSize = 50, ordering = "-transaction_dt" } = {}) => {
    const qp = new URLSearchParams({
      transaction_type: "refund",
      page: String(page),
      page_size: String(pageSize),
      ordering: String(ordering || "-transaction_dt"),
    });
    if (storeId) qp.set("store_id", String(storeId));
    if (startDate) qp.set("start_date", String(startDate));
    if (endDate) qp.set("end_date", String(endDate));
    const data = await apiFetch(`/api/product/transactions/?${qp.toString()}`, { method: "GET" });
    return { ...normalizePagedList(data), page, pageSize };
  }
);

const slice = createSlice({
  name: "returns",
  initialState: {
    status: "idle",
    error: null,
    items: [],
    count: 0,
    page: 1,
    pageSize: 50,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReturns.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchReturns.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload.results || [];
        state.count = action.payload.count ?? 0;
        state.page = action.payload.page || 1;
        state.pageSize = action.payload.pageSize || 50;
      })
      .addCase(fetchReturns.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error?.message || "Не удалось загрузить список возвратов";
      });
  },
});

export default slice.reducer;

export const selectReturns = (state) => state.returns.items || [];
export const selectReturnsCount = (state) => Number(state.returns.count || 0);
export const selectReturnsStatus = (state) => state.returns.status || "idle";
export const selectReturnsError = (state) => state.returns.error || null;
export const selectReturnsPage = (state) => Number(state.returns.page || 1);
export const selectReturnsPageSize = (state) => Number(state.returns.pageSize || 50);
